import { ListItemType, ListTypes } from "components/slate/plugins/list/types";
import { Block } from "thunk-core";

export const isTaskBlock = (block: Block) => {
  return (
    block.type === ListItemType &&
    block.properties.listType === ListTypes.TodoList
  );
};
